module.exports = __webpack_public_path__ + "static/media/edit.b3e87798.png";